import { render, staticRenderFns } from "./cmp-upload-file.vue?vue&type=template&id=31ee1a10&scoped=true"
import script from "./cmp-upload-file.vue?vue&type=script&lang=js"
export * from "./cmp-upload-file.vue?vue&type=script&lang=js"
import style0 from "./cmp-upload-file.vue?vue&type=style&index=0&id=31ee1a10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ee1a10",
  null
  
)

export default component.exports